import service from '@/services/category/CategoryService'
export const categoryModule = {
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state: {
    categoryList: [],
    loadingItems: false,
    pagination: {
      current_page: 1,
      last_page: 1,
      per_page: 10,
    },
  },
  mutations: {
    SET_LIST(state, payload) {
      if (payload.current_page) {
        state.pagination.current_page = payload.current_page
        state.pagination.last_page = payload.last_page
      }
      state.categoryList = payload.data ?? payload
    },
  },
  actions: {
    async getCategories({ commit }, payload) {
      let response = await service.getCategories(payload)
      commit('SET_LIST', response)
    },

    async getCategory(context, payload) {
      let data = await service.getCategory(payload)

      return data
    },

    async insertCategory({ dispatch, state }, payload) {
      let request = service.translateToFirebird(payload)
      const { status } = await service.insert(request)

      dispatch('getCategories', {
        page: state.pagination.current_page,
      })
      return status
    },

    async updateCategory({ dispatch, state }, payload) {
      let request = service.translateToFirebird(payload)
      const { status } = await service.update(request, payload.id)

      dispatch('getCategories', {
        page: state.pagination.current_page,
      })
      return status
    },

    async deleteCategory({ dispatch, state }, payload) {
      const { status } = await service.delete(payload)

      dispatch('getCategories', {
        page: state.pagination.current_page,
      })
      return status
    },
  },
  getters: {
    getComboBoxList: (state) => {
      let comboBox = state.categoryList.map((category) => {
        return {
          CODIGO: category.ID,
          NOME: `${category.ID} - ${category.NOME}`,
        }
      })
      return comboBox
    },
    getCategoriesList: (state) => {
      return state.categoryList
    },
  },
}
